import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.function.name";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 引入工具类
import utils from '@/util/utilsHome';
import $ from 'jquery'; // 引入绘制echarts图表

import { renderOptions } from '@/util/bigScreenCharts';
import { secondToHour } from '@/util/tools';
import { mapGetters } from 'vuex'; // 引入api

import { deviceListMapInfo, statisState, statisWork, distributionData, statisSales } from '@/api/overview/bigScreen.js'; // 引入子组件

import deviceMap from "./deviceMap"; // 地图组件

var moment = require('moment');

import vueSeamlessScroll from 'vue-seamless-scroll';
export default {
  name: 'globalPage',
  data: function data() {
    return {
      nowTimeStr: '',
      // 日期时间
      // 全屏地图 对话框相关
      fullScreenMapDialogShow: false,
      // 全屏地图对话框显示状态
      qpMapShow: false,
      // 地图组件（全屏）显示状态：目的是显示的时候重新加载子组件，刷新子组件数据
      listData: [{
        value: '1dffsfsfs'
      }, {
        value: '2sfdfsfsf'
      }, {
        value: '342432434的士速遞sad'
      }, {
        value: '442432434的士速遞sad'
      }, {
        value: '542432434的淡定點士速遞sad'
      }],
      deviceData: [],
      // 设备列表
      progress: [],
      // 进度条
      info: {},
      //设备状态统计
      cityData: [],
      //城市分布
      saleData: [] // 销售数据

    };
  },
  computed: _objectSpread({
    username: function username() {
      var username = localStorage.getItem('ms_username');
      return username ? username : this.name;
    },
    classOption: function classOption() {
      return {
        step: 0.2,
        limitMoveNum: 4,
        //这个是修改moveSwitch()之前的使用方法，这里的数值指的是数据条数
        openTouch: false,
        singleHeight: 25,
        waitTime: 0
      };
    }
  }, mapGetters(['userInfo'])),
  components: {
    deviceMap: deviceMap,
    vueSeamlessScroll: vueSeamlessScroll
  },
  created: function created() {
    this.nowTimeStr = moment().format('YYYY-MM-DD');
  },
  mounted: function mounted() {
    // 初始化先隐藏设备信息面板
    $('#devicepanel').hide(); // this.$store.dispatch('GetUserInfo');

    this.querydeviceList();
    this.queryInfo();
    this.queryLongTime();
    this.queryCityData();
    this.querySaleData();
  },
  methods: {
    /*
     * 方法函数
     */
    // 点击 顶部标题
    titleClick: function titleClick() {
      // 跳转到index页面
      this.$router.push('/wel/index');
    },
    // 退出登录
    logoutFunc: function logoutFunc() {
      var _this = this;

      // 清除浏览器本地存储中的所有数据
      utils.sessionClearStore();
      this.$store.dispatch('LogOut').then(function () {
        _this.$router.push({
          path: '/login'
        });
      }); // 跳转到登录页面---刷新页面后，因为userId被清空，路由拦截会自动跳转到登录页，所以不需要添加下面这行代码。
      // this.$router.push('/login')
    },
    drawBarChart: function drawBarChart(id, options) {
      // console.log(options, 'optionss-')
      var myChart = echarts.init(document.getElementById(id)); // 使用 aidState做填充，fakeState显示小线条

      myChart.showLoading({
        text: '正在加载...'
      });
      myChart.hideLoading();
      myChart.setOption(options, window.onresize = myChart.resize);
    },
    // 点击 地图展示的 全屏
    fullScreenClick: function fullScreenClick() {
      // 全屏地图对话框显示状态---显示
      this.fullScreenMapDialogShow = true; // 地图组件（全屏）显示状态---显示

      this.qpMapShow = true;
    },
    // 点击关闭 全屏地图 对话框
    fullScreenMapClose: function fullScreenMapClose(done) {
      // 地图组件（全屏）显示状态---隐藏
      this.qpMapShow = false; // 关闭对话框

      done();
    },
    toAlarmPage: function toAlarmPage() {
      this.$router.push('/deviceManage');
    },
    querydeviceList: function querydeviceList() {
      var _this2 = this;

      deviceListMapInfo().then(function (res) {
        if (res.data.code === 200) {
          console.log(res.data.data);
          _this2.deviceData = res.data.data;
        } else {
          _this2.$message.error(res.data.msg);

          return;
        }
      });
    },
    queryInfo: function queryInfo() {
      var _this3 = this;

      statisState().then(function (res) {
        if (res.data.code === 200) {
          // console.log(res.data.data)
          _this3.info = res.data.data;
        } else {
          _this3.$message.error(res.data.msg);

          return;
        }
      });
    },
    queryLongTime: function queryLongTime() {
      var _this4 = this;

      statisWork().then(function (res) {
        if (res.data.code === 200) {
          var data = res.data.data;
          var len = data.length >= 4 ? 3 : data.length;
          _this4.progress = []; // console.log(data[0],' ---data[0]-')

          var count = data[0].runLength + (data[1] ? data[1].runLength : 0) + (data[2] ? data[2].runLength : 0);

          for (var i = 0; i < len; i++) {
            var obj = {};
            obj.name = data[i].name; //   if (i == 1) {
            //     console.log(data[i].runLength, 'aaass',secondToHour(data[i].runLength),'secondToHour')   
            //   }
            // debugger

            obj.time = secondToHour(data[i].runLength);
            obj.percent = (data[i].runLength / data[i].totalLength * 100).toFixed(2) + '%';

            _this4.progress.push(obj);
          }
        } else {
          _this4.$message.error(res.data.msg);

          return;
        }
      });
    },
    queryCityData: function queryCityData() {
      var _this5 = this;

      distributionData().then(function (res) {
        if (res.data.code === 200) {
          var data = res.data.data;
          var len = data.length >= 5 ? 5 : data.length;
          _this5.cityData = res.data.data;
          var xAxisAry = [],
              serialAry = [];

          for (var i = 0; i < len; i++) {
            xAxisAry.push(data[i].province);
            serialAry.push(data[i].num);
          }

          var serial = [{
            name: '设备分布',
            type: 'bar',
            barWidth: 20,
            itemStyle: {
              barBorderRadius: '5,5,0,0'
            },
            data: serialAry
          }];
          var tipsformatter = '{b}<br/>{a}:{c}' + '台';
          var options = renderOptions({
            xAxis: xAxisAry,
            series: serial,
            tipsformatter: tipsformatter
          });

          _this5.drawBarChart('mainCityEcharts', options);
        } else {
          _this5.$message.error(res.data.msg);

          return;
        }
      });
    },
    querySaleData: function querySaleData() {
      var _this6 = this;

      statisSales().then(function (res) {
        if (res.data.code === 200) {
          if (!res.data.data.length) {
            return;
          }

          _this6.saleData = res.data.data;
          var data = res.data.data;
          var xAxisAry = [],
              serialAry = [];

          for (var i = 0; i < data.length; i++) {
            xAxisAry.push(data[i].time);
            serialAry.push(data[i].num);
          }

          var serial = [{
            name: '',
            type: 'bar',
            barWidth: 20,
            data: serialAry
          }];
          var tipsformatter = '{b}:{c}' + '台';
          var options = renderOptions({
            xAxis: xAxisAry,
            series: serial,
            tipsformatter: tipsformatter
          });

          _this6.drawBarChart('monthEcharts', options);
        } else {
          _this6.$message.error(res.data.msg);

          return;
        }
      });
    }
  }
};